/**
 * External Dependencies
 */
 import $, {hasData} from 'jquery'
 import slick from 'slick-carousel'
 import geocomplete from 'geocomplete'
 import AOS from 'aos';

$(() => {



  $('.gall_slideshow').slick({
    rows: 0,
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1
});

/* gallery di prodotto */
$('.products, .gal_mobile').slick({
  rows: 0,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 940,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 540,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});


$('.gal_cats').slick({
  rows: 0,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  variableWidth:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 540,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

/* gallery card */
$('.card_cats').slick({
  rows: 0,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth:true
});

/* gallery di animazione */
$('.gall_animation').slick({
  rows: 0,
  arrows: false,
  infinite: true,
  speed: 300,
  fade:true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:true,
  autoplaySpeed: 700
});

/* gallery della storia */
$('.story-list').slick({
  rows:0,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  infinite: false,
  centerMode: true,
  adaptiveHeight: true,
  asNavFor: '.toc-story'
});
$('.toc-story').slick({
  rows:0,
  slidesToShow: 10,
  slidesToScroll: 1,
  asNavFor: '.story-list',
  focusOnSelect: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 540,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    }
  ]
});

/* gallery news */
$('.news-gal').slick({
  rows:0,
  slidesToScroll: 1,
  infinite: false,
  variableWidth: true,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },{
        breakpoint: 1023,
        settings: "unslick"
     }
  ]
});

/* accordion in pagina */
const $btnacc = $('.accordion-block .accordion-heading');
const $submit= $('#newsletter input[type=submit]');
$btnacc.on('click', function (e) {
  let panel = $(this).data('target');

  if($(this).hasClass('newsbtn')){
    $(this).removeClass('collapsed');
    $('#'+panel).slideDown();


    $(this).on('click', function (e) {
    $submit.trigger('click');
    });
  } else {
    $(this).toggleClass('collapsed');
    $('#'+panel).slideToggle();

  }

    //   let parent = $(this).data('parent');
    // $('#'+parent).siblings('.accordion-block').find('.accordion-content').slideUp();


    return false;

});

/* tabs in pagina */
// Tab buttons
const $btntabs = $('.tabcont-block .toc-tab li');


$btntabs.on('click', function (e) {

    let target = $(this).data('target');
    $(this).addClass('active').removeClass('initialize').siblings().removeClass('active').removeClass('initialize');
    $('#' + target).addClass('open').removeClass('initialize').siblings().removeClass('open').removeClass('initialize');

});


// Gutenberg Block Hot Spot retrieve text
const $dot=$('.image-hotspot .dot');
const $box=$('#hotspot-box');
const $hot=$(".hotspot-in-page img");

$dot.on('click', function(e) {

  if($(this).hasClass('focused')){
    $(this).removeClass('focused');
    $box.find('.dynamic-content').html('');

  } else {
    if($(this).addClass('focused'))

  $box.addClass('open');
  var name=$(this).find('.tooltip-container__block--productName .tooltip-container__block__text').html();
  var txt=$(this).find('.tooltip-container__block--productShortDescription .tooltip-container__block__text').html();
  var img=$(this).find('.tooltip-container__block--productFeaturedImage').html();

  $box.find('.dynamic-content').html('<div class="hotspot-img">'+img+'</div><h3>'+name+'</h3><div>'+txt+'</div>');
  }

});

$($hot).on('click', function(e)  {
  $box.find('.dynamic-content').html('');

});


  // Bottoni che aprono un target
  const $btnop=$('.open-button');
  const $catfield=$('form input[name=catalogue]');
  const $catname=$('form input[name=cat_name]');
  $btnop.on('click', function(e) {
    e.stopPropagation();
    let $target = $(this).data('target');
    let $catid=  $(this).data('id');
    if($catid){
      $catfield.val($catid);
      $catname.val($catid);
    }
    if($(this).hasClass('chiudi') || $(this).hasClass('open')) {
      $('body').css('overflow','visible');
      $('#' + $target).removeClass('open');

    } else {
      $('#' + $target).addClass('open');
      $('body').css('overflow','hidden');
    }

    $(this).toggleClass('open');

  });

   // Menu button
   const $btncat=$('.open-cat');
   let linee=$('.categoria');
   let lineeback=$('.categoria-back');

   $btncat.on('click', function(e) {
     e.stopPropagation();

     let target = $(this).data('category');
     let panel = $(this).data('panel');
     let etichetta = $(this).data('title');
     let back = $(this).data('back');

     $('#'+panel + ' .categoria').html(etichetta);
    lineeback.html(back);

      if(panel=='menu-linee'){
        $('#menu-funzioni').removeClass('open');
      }

     $(this).siblings().removeClass('open');
     $(this).toggleClass('open');
     $('#'+panel).addClass('open');

     $('#cat-'+target).siblings().removeClass('open');
     $('#cat-'+target).addClass('open');

   });

// Sub Menu button
const $btnmenu=$('.menu .open-menu');

$btnmenu.on('click', function(e) {
  e.stopPropagation();

  let panel = $(this).data('panel');

  $(this).siblings().removeClass('open');
  $('#'+panel).siblings().removeClass('open');

  if(!$(this).hasClass('open')) {
    $(this).toggleClass('open');
  }

  $('#'+panel).addClass('open');


});

   let $megamn=$('.mega-menu');
   $('.nav-primary a[href^="#"], #search').on('click', function(e) {
    e.preventDefault;
    $megamn.removeClass('open');
    $megamn.find('.panel, li').removeClass('open');

    let target = $(this).attr('title');

    if(target){
      $('#'+target).toggleClass('open');
    }

    $('body').addClass('open').css('overflow', 'hidden');

   });


   const $chiudi=$('.chiudi-menu');

   $chiudi.on('click', function(e) {
    let $menu=$(this).data('target');

    $('#'+$menu).find('.panel, li').removeClass('open');
    setTimeout(function() {
      $('#'+$menu).removeClass('open');
    }, 120);

    $('body').removeClass('open').css('overflow', 'visible');

   });

   // Language button
   const $language=$('.wpml-ls-legacy-list-horizontal');
   const $current=$('.wpml-ls-legacy-list-horizontal .wpml-ls-current-language .wpml-ls-native').html();

   $language.prepend( '<span id="current">'+$current+'</span>' );

// Smoth scroll for anchors
$('#main a[href^="#"]').on('click', function(e) {
  $('html, body').animate({
      scrollTop: $('[id="' + $.attr(this, 'href').substr(1) + '"]').offset().top -130
  }, 500);

  return false;
});

//floating label

$(".wpcf7 .wpcf7-form-control")
  .on("focus", function () {
      $(this).parents("label").addClass("floating-label-active");
  })
  .on("blur", function () {
      if ($(this).val().length === 0) {
          $(this).parents("label").removeClass("floating-label-active");
      }
  });



  function enableGeoCoding($context = undefined) {
    $("input[name='provincia']:not(.geocoding-active)", $context)
    .addClass('geocoding-active')
    .geocomplete()
    .bind("geocode:result", function(event, result){
      const $geoLocalita = $('input[name="geo-localita"]');
      const $geoCitta = $('input[name="geo-citta"]');
      const $geoProvincia = $('input[name="geo-provincia"]');
      const $geoRegione = $('input[name="geo-regione"]');
      const $geoNazione2 = $('input[name="geo-nazione"]');
      const $geoPostal = $('input[name="geo-postal"]');


      for( let a in result.address_components){
        const component = result.address_components[a];

        if(component.types.includes("locality") && $geoLocalita.length > 0){$geoLocalita.val(component.short_name);}
        if(component.types.includes("administrative_area_level_3") && $geoCitta.length > 0){$geoCitta.val(component.short_name);}
        if(component.types.includes("administrative_area_level_2") && $geoProvincia.length > 0){$geoProvincia.val(component.short_name);}
        if(component.types.includes("administrative_area_level_1") && $geoRegione.length > 0){$geoRegione.val(component.short_name);}
        if(component.types.includes("country") && $geoNazione2.length > 0){$geoNazione2.val(component.short_name);}
        if(component.types.includes("postal_code") && $geoPostal.length > 0){$geoPostal.val(component.short_name);}
      }
    });
  }

  enableGeoCoding();


  /* Compile cf7 catgory and lines */
  const $cat_prod=$('select[name="cat_prod"]');
  const $categoria=$('input[name="categoria"]');
  const $cat_line=$('select[name="cat_line"]');
  const $linea=$('input[name="linea"]');

  $cat_prod.on('change', function (e) {
    var optionSelected = $("option:selected", this);
    console.log(optionSelected);
    $categoria.val(optionSelected.text());
  });

  $cat_line.on('change', function (e) {
    var optionSelected = $("option:selected", this);
    $linea.val(optionSelected.text());
  });



})

$(window).on('load', function(){
  if (!$('.page-template-template-policies').length) {
    const $fadeup=$('.wp-block-heading');
    const $fade=$('.wp-block-image img, p');
    $fadeup.attr('data-aos','fade-up').attr('data-aos-duration',700);
    $fade.attr('data-aos','fade');
    AOS.init();
  }
});

$(document.body).on('touchmove', onScroll); // for mobile
$(window).on('scroll', onScroll);

// callback
const $numero = $(".counter-block");
const $numeri=$('.numero .grande');

function counter() {
  $numero.addClass('animate');

  $numeri.each(function() {
    var $this = $(this),
      countTo = $this.attr('data-count');

    $({ countNum: $this.children('span').text()}).animate({
    countNum: countTo },

  {

  duration: 800,
  easing:'linear',
  step: function() {
    $this.text(Math.floor(this.countNum));
  },
  complete: function() {
    $this.text(this.countNum);
    //alert('finished');
  } });   });
}
function onScroll() {

  let windowBottom = $(this).scrollTop() + $(this).height() - 400;

  if ($numero.length) {
    // start animation number enter in page
    if ((windowBottom + 150) >= $numeri.offset().top) {
        if(!$numero.hasClass('animate')) {
        counter();
      }
    }
}
}


/* Iubenda custom */
$(() => {
  $(window).on('load', function () {
    const iubendaBtn = $('button.iubenda-tp-btn.iubenda-cs-preferences-link');
    if (iubendaBtn.length && groot.isHomepage) {
      const iubendaBtnStyle = iubendaBtn.attr('style');
      iubendaBtn.attr('style', iubendaBtnStyle + 'bottom:6rem!important;');
    }
  });
});
